import Calendar from '../../../../api/api-calendar';
import * as types from '../constants/action-types';
import { get } from 'lodash';

const fetchCalendarPricingRequest = (listingToFetch) => {
  return {
    type: types.CALENDAR_PRICING_FETCH_REQUEST,
    listingToFetch
  };
};

const fetchCalendarPricingSuccess = (data) => {
  return {
    type: types.CALENDAR_PRICING_FETCH_SUCCESS,
    data
  };
};

const fetchCalendarPricingFailure = (fetchError) => {
  return {
    type: types.CALENDAR_PRICING_FETCH_FAILURE,
    fetchError
  };
};

const clearCalendarListingData = () => {
  return {
    type: types.CALENDAR_PRICING_CLEAR_STORE
  };
};

const updateCalendarPricingRequest = () => {
  return {
    type: types.CALENDAR_PRICING_UPDATE_REQUEST,
    isPatching: true
  };
};

const updateCalendarPricingSuccess = () => {
  return {
    type: types.CALENDAR_PRICING_UPDATE_SUCCESS,
    isPatching: false
  };
};

const updateCalendarPricingFailure = (updateError) => {
  return {
    type: types.CALENDAR_PRICING_UPDATE_FAILURE,
    updateError,
    isPatching: false
  };
};

const deleteCalendarPricingRequest = () => {
  return {
    type: types.CALENDAR_PRICING_DELETE_REQUEST,
    isPatching: true
  };
};

const deleteCalendarPricingSuccess = () => {
  return {
    type: types.CALENDAR_PRICING_DELETE_SUCCESS,
    isPatching: false
  };
};

const deleteCalendarPricingFailure = (deleteError) => {
  return {
    type: types.CALENDAR_PRICING_DELETE_FAILURE,
    isPatching: false,
    deleteError
  };
};

const postCalendarPricingRequest = () => {
  return {
    type: types.CALENDAR_PRICING_CREATE_REQUEST
  };
};

const postCalendarPricingSuccess = () => {
  return {
    type: types.CALENDAR_PRICING_CREATE_SUCCESS
  };
};

const postCalendarPricingFailure = (postError) => {
  return {
    type: types.CALENDAR_PRICING_CREATE_FAILURE,
    postError
  };
};

export const fetchCalendarPricing = (listingId) => {
  return dispatch => {
    return new Promise((resolve, reject) => {
      dispatch(fetchCalendarPricingRequest());
      Calendar.readAnonymousV2(listingId, (response) => {
        if (200 === response.statusCode) {
          dispatch(fetchCalendarPricingSuccess(response));

          return resolve(response);
        }
        const error = (response || {}).error;
        dispatch(fetchCalendarPricingFailure(error));
        return reject(error);
      });
    });
  };
};

export const postCalendarPricing = (payload, listingId, token) => {
  return dispatch => {
    return new Promise((resolve, reject) => {
      dispatch(postCalendarPricingRequest());
      Calendar.createCalendarPricing(payload, listingId, token, (response) => {
        if (200 === response.statusCode) {
          dispatch(postCalendarPricingSuccess(response));

          return resolve(response);
        }

        dispatch(postCalendarPricingFailure(response));
        return reject(response);
      });
    });
  };
};

export const updateCalendarPricing = (listingId, token, payload) => {
  return dispatch => {
    return new Promise((resolve, reject) => {
      dispatch(updateCalendarPricingRequest());
      return Calendar.update(`prices/${listingId}`, token, payload, (response) => {
        if (200 === response.statusCode) {
          const { statusCode, ...data } = response;
          dispatch(updateCalendarPricingSuccess(data));
          return resolve(data);
        }

        const fetchError = get(response, 'error', '');
        dispatch(updateCalendarPricingFailure(fetchError));
        return reject(fetchError);
      });
    });
  };
};

export const deleteCalendarPricing = (groupId, token) => {
  return dispatch => {
    return new Promise((resolve, reject) => {
      dispatch(deleteCalendarPricingRequest());
      return Calendar.deleteCalendarPricing(groupId, token, (response) => {
        if (200 === response.statusCode) {
          const { statusCode, ...data } = response;
          dispatch(deleteCalendarPricingSuccess(data));
          return resolve(data);
        }

        const fetchError = get(response, 'message', '');
        dispatch(deleteCalendarPricingFailure(fetchError));
        return reject(fetchError);
      });
    });
  };
};

export const clearListingStore = () => {
  return dispatch => {
    dispatch(clearCalendarListingData());
  };
};

export const updateShowVariablePriceForm = (bool) => {
  return dispatch => {
    return dispatch({
      type: types.SHOW_VARIABLE_PRICING_FORM,
      showVariablePricingForm: bool
    });
  };
};

export const updateShowVariableAttendeeForm = (bool) => {
  return dispatch => {
    return dispatch({
      type: types.SHOW_VARIABLE_ATTENDEE_FORM,
      showAttendeePricingForm: bool
    });
  };
};
